export default __webpack_public_path__ + "static/media/inr_yellow.e4163726.svg";